class RouteSummaryRoutesRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "RouteSummaryRoutes";

    super(entityName);

    var options = Monet.Grid.Utils.paginationOptions;

    if (!App.Forms.RouteSummaryRoutes) {
      App.Forms[this.entityName] = {
        layout: {},
        dataMapper: null,
        pagination: {
          first: options.FIRST,
          max: options.MAX_RESULT,
          blocked: false,
          canIncrement: true
        },
        columnToOrders: [
          {
            field: "route.date",
            order: "DESC"
          }
        ]
      };
    }

    if (!App.Objects.RouteSummaryRoutes) {
      App.Objects.RouteSummaryRoutes = this;
    }
  }

  getFieldsToGridLayout = callback => {
    var pageLayout = new Monet.PageLayout();
    pageLayout.getLayout(
      "RouteView",
      "index",
      function(data) {
        if (data) {
          App.Forms.RouteSummaryRoutes.layout["index"] = data;
        }
        if (callback) {
          callback();
        }
      },
      "RouteSummaryRoutes"
    );
  };

  updateGrid = (filter, callback, appendCollection, action) => {
    var error = null,
      that = this,
      _filter = {},
      columns = [],
      tableLayout = null,
      routeCollection = null,
      pagination = {},
      projectionBuilder = null,
      processProjection,
      addPaginationGrid = true,
      fieldsCustom = [
        {
          name: "route.id"
        },
        {
          name: "route.key"
        },
        {
          name: "route.date"
        },
        {
          name: "route.totalStops"
        },
        {
          name: "route.canceledStops"
        },
        {
          name: "route.redeliveredStops"
        },
        {
          name: "route.actualDepartures"
        },
        {
          name: "route.organization.description"
        },
        {
          name: "route.status"
        },
        {
          name: "routePercentage"
        },
        {
          name: "stopView"
        },
        {
          name: "route.undeliveredStops"
        },
        {
          name: "totalStopsInProgress"
        }
      ];

    try {
      if (filter) {
        _filter = filter;
      }

      columns = App.Forms.RouteSummaryRoutes.table.getColumns();
      tableLayout = App.Forms.RouteSummaryRoutes.layout.index;
      filter = App.Forms.RouteSummaryRoutes.filterBuilder;

      if (action === "update") {
        var firstResult = 0;
        var pages;
        var updater;
        var page;
        var options;

        options = Monet.Grid.Utils.paginationOptions;
        updater = App.Forms.RouteSummaryRoutes.controlUpdater;

        page = updater.getPageByScrollPosition();

        pages = updater.getPages();

        if (page !== 0) {
          firstResult = pages[page].firstResult;
        }

        pagination.first = firstResult;
        pagination.max = options.MAX_RESULT;
      } else {
        pagination = App.Forms.RouteSummaryRoutes.pagination;
      }

      routeCollection = new App.Collections.RouteViews();
      projectionBuilder = new Monet.Builder.Projection();

      projectionBuilder.setLayout(tableLayout);
      projectionBuilder.parseLayout();
      projectionBuilder.addFields(fieldsCustom);

      projectionBuilder.setPagination(pagination);

      processProjection = projectionBuilder.projection.toString();

      if (appendCollection) {
        routeCollection.reset();
      }

      filter.filterButton.showLoading();
      App.Forms.RouteSummaryRoutes.pagination.blocked = true;
      App.Forms.RouteSummaryRoutes.searchInProgress = true;

      routeCollection.filterWithRestrictions({
        filter: _filter,
        criteria: processProjection,
        restrictionUrl: '/Summary',
        success: (result) => {
          App.Views.RouteSummary.adjustGridHeight();
          if (callback) {
            callback(that.entityName, columns, result, addPaginationGrid);
          }
          filter.loading.hide();
          filter.filterButton.hideLoading();
          App.Forms.RouteSummaryRoutes.pagination.blocked = false;
          App.Forms.RouteSummaryRoutes.searchInProgress = false;
        },
        error: (result) => {
          App.Views.RouteSummary.showAlertMessageError(result);
          callback(that.entityName, columns, routeCollection, addPaginationGrid);
          filter.loading.hide();
          filter.filterButton.hideLoading();
          App.Forms.RouteSummaryRoutes.pagination.blocked = false;
          App.Forms.RouteSummaryRoutes.searchInProgress = false;
        }
      });
    } catch (e) {
      error = new Monet.Exception.ReturnError(
        this,
        "Error on update route monitoring route",
        e
      );
      error.console();
    }
  };

  updateSideBar = () => {
    Greenmile.RouteSummary.SideBar.getRoutesStatistics();
  };

  getFilter = (defaultFilter = {}) => {
    var filter = {
        sort: []
      },
      columnToOrderLength = 0,
      columnToOrder,
      _filter;

    columnToOrder = App.Forms.RouteSummaryRoutes.columnToOrders;

    _filter = App.Forms.RouteSummaryRoutes.filterBuilder;

    if (_filter) {
      var criteriaByFilterBuilder = _filter.getCriteriaChain();

      filter.criteriaChain = criteriaByFilterBuilder.criteriaChain;
    }

    if (columnToOrder) {
      columnToOrderLength = columnToOrder.length;

      for (var i = 0; i < columnToOrderLength; i++) {
        filter.sort.push({
          attr: columnToOrder[i].field,
          type: columnToOrder[i].order
        });
      }
    }

    return filter;
  };
}

App.Routers.RouteSummaryRoutes = RouteSummaryRoutesRouter;
